import { useCallback } from 'react';

import { useSeek } from '@/scenarios/legacy-player/hooks/useSeek';

import { useUserActionIndicatorChangers } from './use-user-action-indicator';

export const useSeekWithIndicator = () => {
    const {
        seekToTime,
        seekForward: instanceSeekForward,
        seekBackward: instanceSeekBackward,
    } = useSeek();
    const { showSeekForward, showSeekBackward } = useUserActionIndicatorChangers();

    const seekForward = useCallback(
        (seekInterval: number) => {
            showSeekForward();
            instanceSeekForward(seekInterval);
        },
        [instanceSeekForward, showSeekForward]
    );

    const seekBackward = useCallback(
        (seekInterval: number) => {
            showSeekBackward();
            instanceSeekBackward(seekInterval);
        },
        [instanceSeekBackward, showSeekBackward]
    );

    return { seekBackward, seekForward, seekToTime };
};
